import { useEffect, useRef, useState } from "react";

const CURSORS = ["🚀", "👾", "🛸", "⚡", "🎮", "💫"];

const AtariCursor = () => {
  const [pos,    setPos]    = useState({ x: -100, y: -100 });
  const [idx,    setIdx]    = useState(0);
  const [firing, setFiring] = useState(false);
  const [trail,  setTrail]  = useState([]);
  const trailRef = useRef([]);

  useEffect(() => {
    // موس معمولی رو مخفی کن
    document.body.style.cursor = "none";

    const onMove = (e) => {
      const pos = { x: e.clientX, y: e.clientY };
      setPos(pos);
      trailRef.current = [...trailRef.current.slice(-8), pos];
      setTrail([...trailRef.current]);
    };

    const onTouch = (e) => {
      const t = e.touches[0];
      const p = { x: t.clientX, y: t.clientY };
      setPos(p);
    };

    const onClick = () => {
      setIdx(i => (i + 1) % CURSORS.length);
      setFiring(true);
      setTimeout(() => setFiring(false), 200);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("touchmove",  onTouch, { passive: true });
    window.addEventListener("click",      onClick);

    return () => {
      document.body.style.cursor = "";
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("touchmove",  onTouch);
      window.removeEventListener("click",      onClick);
    };
  }, []);

  return (
    <>
      {/* trail */}
      {trail.map((p, i) => (
        <div
          key={i}
          style={{
            position:      "fixed",
            left:          p.x,
            top:           p.y,
            transform:     "translate(-50%,-50%)",
            fontSize:      `${8 + i * 1.2}px`,
            opacity:       (i / trail.length) * 0.5,
            pointerEvents: "none",
            zIndex:        9998,
            transition:    "none",
            userSelect:    "none",
            filter:        "blur(0.5px)",
          }}
        >
          ✦
        </div>
      ))}

      {/* cursor اصلی */}
      <div
        style={{
          position:      "fixed",
          left:          pos.x,
          top:           pos.y,
          transform:     "translate(-50%,-50%)",
          fontSize:      firing ? "32px" : "24px",
          pointerEvents: "none",
          zIndex:        9999,
          userSelect:    "none",
          transition:    "font-size 0.1s",
          filter:        firing
            ? "drop-shadow(0 0 8px #0f0) drop-shadow(0 0 16px #0f0)"
            : "drop-shadow(0 0 4px #0f0)",
          animation:     "atari-float 1.5s ease-in-out infinite",
        }}
      >
        {CURSORS[idx]}
      </div>

      {/* label زیر cursor */}
      <div
        style={{
          position:        "fixed",
          left:            pos.x,
          top:             pos.y + 20,
          transform:       "translateX(-50%)",
          fontFamily:      "'Courier New', monospace",
          fontSize:        "9px",
          color:           "#0f0",
          pointerEvents:   "none",
          zIndex:          9999,
          userSelect:      "none",
          letterSpacing:   "1px",
          textShadow:      "0 0 6px #0f0",
          whiteSpace:      "nowrap",
        }}
      >
        {["SHIP","ALIEN","UFO","ZAP","GAME","STAR"][idx]}
      </div>

      <style>{`
        @keyframes atari-float {
          0%,100% { transform: translate(-50%,-50%) rotate(-5deg) scale(1); }
          50%      { transform: translate(-50%,-54%) rotate(5deg) scale(1.1); }
        }
      `}</style>
    </>
  );
};

export default AtariCursor;